module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./AfterSaleListView.js"));
	}, "AfterSaleListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleListView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleList/AfterSaleListView.js
// module id = 1049
// module chunks = 431